export default __webpack_public_path__ + "static/media/mario.86b7a39e.jpg";